<div class="header p-0">
	<!-- Every page renders its own .header-bar absolutely positioned into this same 55px row, so it has to know
	     how much of the row is already spoken for. These two blocks publish their real widths as CSS variables
	     (see publishHeaderWidths) instead of the page bar guessing at a flat reserved width. -->
	<div #headerLeft class="header-left d-flex align-items-center">
		<div *ngIf="isCorporate() && selectedFranchiseId()" class="ms-5" style="width: 400px">
			<slick-drop-down [ngModel]="selectedFranchiseId()" [items]="franchises()" [allowEmpty]="false" (onSelect)="onFranchiseChange($event)"></slick-drop-down>
		</div>
		<div *ngIf="isCorporate() && selectedTimeZoneId()" class="ms-5" style="width: 300px">
			<slick-drop-down [ngModel]="selectedTimeZoneId()" [items]="timeZones()" [allowEmpty]="false" (onSelect)="onTimeZoneChange($event)"></slick-drop-down>
		</div>
	</div>
	<div class="header-spacer"></div>
	<div #headerRight class="menu-right">
		<div class="me-3" style="width: 340px">
			<global-search-bar></global-search-bar>
		</div>
		<button class="btn btn-danger signout-button" (click)="logout()">Sign Out</button>
		<tasks *ngIf="canViewTasks"></tasks>
		<notifications></notifications>
		<button #popoverRef class="ms-1 me-3 btn btn-info btn-custom-info text-white btn-sm">Need Help?</button>
		<slick-popover showByClick="true" [element]="popoverRef" position="bottom">
			<div class="support-panel p-3" style="min-width: 400px">
				<h4 class="mb-3 fw-bold">We're here for you!</h4>

				<!-- "Onboarding Portal" here is Learning Paths (/sight-school), not Onboarding Setup - so while Learning
				     Paths is switched off this stays the single Video Library link it has always been. -->
				<ng-container *ngIf="isLearningPathsEnabled; else sightSchoolLink">
					<div class="support-label">
						<i class="fad fa-play"></i>
						<span>Sight School</span>
					</div>
					<div class="support-item support-item-sub" [routerLink]="['/sight-school']">
						<i class="fad fa-play"></i>
						<span>Onboarding Portal</span>
						<i class="fad fa-chevron-right ms-auto"></i>
					</div>
					<div class="support-item support-item-sub" onclick="window.open('https://fast.wistia.com/embed/channel/jvv59mc5e0?wchannelid=jvv59mc5e0','_blank')">
						<i class="fad fa-play"></i>
						<span>Video Library</span>
						<i class="fad fa-chevron-right ms-auto"></i>
					</div>
				</ng-container>
				<ng-template #sightSchoolLink>
					<div class="support-item" onclick="window.open('https://fast.wistia.com/embed/channel/jvv59mc5e0?wchannelid=jvv59mc5e0', '_blank')">
						<i class="fad fa-play"></i>
						<span>Sight School</span>
						<i class="fad fa-chevron-right ms-auto"></i>
					</div>
				</ng-template>

				<div class="support-item" onclick="window.open('https://jobsight.com/training', '_blank')">
					<i class="fad fa-person-chalkboard"></i>
					<span>Live Training</span>
					<i class="fad fa-chevron-right ms-auto"></i>
				</div>

				<div class="support-item" (click)="showVersionHistory()">
					<i class="fad fa-history"></i>
					<span>Release Notes</span>
					<i class="fad fa-chevron-right ms-auto"></i>
				</div>

				<div class="support-item" onclick="window.open('https://forms.zohopublic.com/jobsight1/form/Contactforsupport/formperma/QJkD52MQeyERlCFVttsy5cN72LiT1B_9wjS1mqO9TRg', '_blank')">
					<i class="fad fa-ticket"></i>
					<span>Submit Ticket</span>
					<i class="fad fa-chevron-right ms-auto"></i>
				</div>

				<div *ngIf="idStartsWith911()" class="support-item" onclick="window.open('https://jobsight.com/911-restoration-resource-hub', '_blank')">
					<i class="fad fa-home"></i>
					<span>911 Resource Hub</span>
					<i class="fad fa-chevron-right ms-auto"></i>
				</div>

				<div *ngIf="!isBlockedFromFeatureIdeas" class="support-item" [routerLink]="['/feature-ideas']">
					<i class="fad fa-lightbulb"></i>
					<span>Feature Ideas</span>
					<i class="fad fa-chevron-right ms-auto"></i>
				</div>
			</div>
		</slick-popover>
		<div class="profile-container" [routerLink]="['/userSettings']">
			<div class="profile-name text-light">{{ firstName }}</div>
			<img *ngIf="profilePictureUrl" [src]="profilePictureUrl" />
		</div>
		<learning-path-badge *ngIf="isLearningPathsEnabled" [size]="40" [overlapPx]="14" (click)="$event.stopPropagation()"></learning-path-badge>

	</div>
</div>

<div class="header-shadow"></div>

<version-release-dialog #versionDialog [isOpen]="showDialog" (onClose)="onVersionDialogClose()" [isMobile]="false"></version-release-dialog>
